import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
//import Cookies from "js-cookie";
import {setAccessToken, setLoggedUser} from './Auth';
import logo from './assets/images/attitude_crafters_logo.png';
import {endpoint} from './config';


const Login = () => {
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const login = async () => {
    //console.log("submit");
    //navigate("/home");

    const params = new FormData();
    params.append("email", username);
    params.append("password", password);

    const response = await axios.post(`${endpoint}/auth`, params);
    const data = response.data;
    if (data.status) {
      axios.defaults.headers.common['Authorization'] = "Bearer " + data.token;
      //const expires = 5 * (60 * 60) * 24; //5 days
      const expires = 5; //5 days
      //Cookies.set("access_token", data.token, expires);
      setAccessToken(data.token, expires);
      setLoggedUser(JSON.stringify(data.data), expires);

      //localStorage.setItem('token', data.token);
      //localStorage.setItem('data', data.data);
      //Cookies.set("userInfo", JSON.stringify(data.data), expires);
      console.log(data.data);
      if (data.data.userType==="Employee"){
        navigate("/home");
      }else{
        navigate("/");
      }
      
    } else {
      toast(data.message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.log(data.message);
    }
  };

  return (
    <div className="app-container">
      <div className="card login-box" style={{ maxWidth: "500px" }}>
        <div className="card-header d-none">Login</div>
        <div className="card-body">
          <img
            //src={process.env.PUBLIC_URL + "attitude_crafters_logo.png"}
            src={logo}
            alt="Attitude Crafters Logo"
            className="logo"
          ></img>
          <form>
            <div className="form-group">
              <label className="form-label">Email ID</label>
              <input
                className="form-control"
                type="text"
                name="userName"
                value={username}
                placeholder="Email ID"
                onChange={(event) => setUserName(event.currentTarget.value)}
              ></input>
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                className="form-control"
                type="password"
                name="password"
                value={password}
                placeholder="Password"
                onChange={(event) => setPassword(event.currentTarget.value)}
              ></input>
            </div>
            <div className="form-group">
              <button
                className="btn btn-primary btn-login"
                type="button"
                onClick={login}
              >
                Login
              </button>
            </div>
          </form>
        </div>
        <div className="poweredby card-footer text-center">
          Powered by <a rel="noreferrer" href="http://technixindia.com" target={"_blank"}>Technix India Solutions (P) Limited</a>
        </div>
      </div>
    </div>
  );
};

export default Login;
